import { Directive, ElementRef, forwardRef, Input, Renderer2 } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from './value-accessor-base';

@Directive({
    standalone: false,
    selector: 'input[mas-date-nl][ngModel]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => DateNlDirective),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => DateNlDirective),
            multi: true
        }
    ]
})
export class DateNlDirective extends ValueAccessorBase<Date> {
    private _shortDateRegExp: RegExp;
    private _fullDateRegExp: RegExp;
    private _allowRegExp: RegExp;

    @Input("mas-date-min")
    minDate?: string;

    @Input("mas-date-max")
    maxDate?: string;

    @Input("mas-date-min-age")
    minAge?: number;

    constructor(renderer: Renderer2, elementRef: ElementRef) {
        super(renderer, elementRef);
        this._shortDateRegExp = new RegExp('^([0][1-9]|[1|2][0-9]|[3][0|1])([0][1-9]|[1][0-2])([0-9]{4}|[0-9]{2})$');
        this._fullDateRegExp = new RegExp('^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$');
        this._allowRegExp = new RegExp('[0-9\-\/\.]');
    }

    protected format(date: Date): string {
        if (date === null || date === undefined) {
            return '';
        }
        const day: string = '' + date.getDate();
        const month: string = '' + (date.getMonth() + 1);
        return ('0' + day).substr(day.length - 1) + '-' +
               ('0' + month).substr(month.length - 1) + '-' +
               date.getFullYear().toString();
    }

    protected isValidChar(c: string): boolean {
        return this._allowRegExp.test(c);
    }

    protected parse(value: string): { parsed: Date, errors: any } {
        if (value.length > 0) {
            var parseResult = this.TryParse(value);
            if (parseResult.valid) {
                return {
                    parsed: parseResult.date, errors: undefined
                };
            }
            return {
                parsed: parseResult.date, errors: this.getErrorObject(parseResult.reason, value)
            };
        }
        return {
            parsed: undefined, errors: undefined
        };
    }

    private getErrorObject(reason: string, value: string) {
        if (!reason || reason.length == 0) {
            return { 'invalidDate': { value } };
        }
        switch (reason) {
            case 'parseFormatError': {
                return {
                    'parseError': { value }
                }
            }
            case 'invalidDateError': {
                return {
                    'invalidError': { value }
                }
            }
            case 'minDateError': {
                return {
                    'minError': { value }
                }
            }
            case 'maxDateError': {
                return {
                    'maxError': { value }
                }
            }
            case 'minAgeError': {
                return {
                    'minAgeError': { value }
                }
            }
            default: {
                return {
                    'invalidDate': {
                        value,
                        reason
                    }
                };
            }
        }
    }

    private TryParse(value: string): { valid: boolean, validDate: boolean, reason?: string, date?: Date } {

        let items: string[];
        if (this._shortDateRegExp.test(value)) {
            items = value.split(this._shortDateRegExp);
        }
        if (!items && this._fullDateRegExp.test(value)) {
            items = value.split(this._fullDateRegExp);
        }
        if (!items || items.length !== 5) {
            return { valid: false, validDate: false, reason: 'parseFormatError' };
        }

        const day: number = Number(items[1]);
        const month: number = Number(items[2]);
        let year: number = Number(items[3]);

        if (items[3].length === 2) {
            const testYear: number = Number(items[3]) + 2000;
            const plusFive = new Date().getFullYear() + 5;
            if (testYear > plusFive) {
                year += 1900;
            } else {
                year += 2000;
            }
        }

        const date = new Date(Date.UTC(year, month - 1, day));
        if (date && (date.getMonth() + 1) === month) {
            //min-date
            if (this.minDate && this.minDate.length > 0) {
                console.log("minDate:" + this.minDate);
                var checkDate = new Date(this.minDate);
                if (date.valueOf() < checkDate.valueOf()) {
                    return { valid: false, validDate:true, reason: 'minDateError', date: date };
                }
            }
            //max-date
            if (this.maxDate && this.maxDate.length > 0) {                    
                var checkDate = new Date(this.maxDate);
                if (date.valueOf() > checkDate.valueOf()) {
                    return { valid: false, validDate:true, reason: 'maxDateError', date: date };
                }
            }
            // min-age
            if (this.minAge) {
                var age = this.getAge(date);
                if (age < this.minAge) {
                    return { valid: false, validDate: true, reason: 'minAgeError', date: date }
                }
            }
            return { valid: true, validDate: true, date: date };
        }

        return { valid: false, validDate: false, reason: 'invalidDateError' };
    }

    private getAge(birthDate: Date): number {
        var today = new Date();
        var age = today.getFullYear() - birthDate.getFullYear();
        var m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }
}
